import React from 'react'
import Footer from './Footer'
import Home from './Home'
import Navbar from './Navbar'

const App = () => {

    return (
        <div className="app">
            <Navbar/>
            <Home/>
            <Footer/>
           
        </div>
    )
}

export default App
